class Accordion {
  constructor(el) {
    this.$block = $(el);
    this.$items = this.$block.find('.faqs__question');
    this.$btns = this.$block.find('.faqs__button');
    this.$contents = this.$block.find('.faqs__answer');

    this.init();
  }

  init() {
    this.$btns.on('click', (e) => {
      const $cur = $(e.currentTarget);
      const $curRow = $cur.parent();
      if (!$curRow.hasClass('is-opened')) {
        // this.$items.removeClass('is-opened');
        // this.$contents.slideUp();
        $curRow.addClass('is-opened').children('.faqs__answer').slideDown();
      } else {
        $curRow.removeClass('is-opened').children('.faqs__answer').slideUp();
      }
    });
  }
}

export default Accordion;
